import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    json: Boolean
  };

  connect() {
    this.fetchContent();
  }

  async fetchContent() {
    if (!this.urlValue) return;

    // JSON mode (for license editor)
    if (this.jsonValue) {
      try {
        const response = await fetch(this.urlValue, {
          headers: { "Accept": "application/json" },
          credentials: "same-origin"
        });

        const json = await response.json();

        // Dispatch event for license controller
        this.dispatch("loaded", { detail: json });

      } catch (error) {
        console.error("lazy-load JSON fetch error:", error);
      }
      return;
    }

    // HTML mode (existing behavior — unchanged)
    fetch(this.urlValue)
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html;
      })
      .catch(error => {
        console.error("Error fetching content:", error);
        this.element.innerHTML = "<p>Failed to load content.</p>";
      });
  }
}
